import React, { lazy } from 'react';
import { CircleCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SalesLetter() {
  return <section id="presentacion" className="py-10 px-4 bg-[#111]" style={{
    paddingTop: '10px',
    paddingBottom: '10px'
  }} data-id="element-255">
      <div className="max-w-3xl mx-auto text-gray-300 leading-relaxed space-y-4" data-id="element-256">
        {/* "Este Sistema es para vos si..." — compact, high-impact */}
        <h2 className="text-2xl font-bold text-white mb-1" data-id="element-257">
          Este Sistema es{' '}
          <span className="text-[#FF6B00] underline decoration-[#FF6B00] decoration-2" data-id="element-258">
            para vos
          </span>{' '}
          si...
        </h2>

        <ul className="space-y-2" data-id="element-259">
          <li className="flex gap-3 items-start" data-id="element-260">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-261" />
            <span className="text-gray-300 text-[15px]" data-id="element-262">
              Trabajás duro todo el día, pero tus{' '}
              <span className="font-bold text-white" data-id="element-263">
                ingresos siguen igual
              </span>
              … porque siempre hacés los mismos{' '}
              <span className="italic underline decoration-[#FF6B00]/50" data-id="element-264">
                trabajos básicos.
              </span>
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-265">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-266" />
            <span className="text-gray-300 text-[15px]" data-id="element-267">
              Sabés que podrías fabricar{' '}
              <span className="font-bold text-white" data-id="element-268">cosas increíbles</span>…
              pero no tenés un{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-269">
                paso a paso claro
              </span>{' '}
              y terminás postergando proyectos que{' '}
              <span className="italic" data-id="element-270">nunca arrancan.</span>
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-271">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-272" />
            <span className="text-gray-300 text-[15px]" data-id="element-273">
              <span className="font-bold text-white" data-id="element-274">Perdés dinero</span>{' '}
              desperdiciando barras de hierro completas por trabajar{' '}
              <span className="italic" data-id="element-275">"a ojo"</span>{' '}
              <span className="underline decoration-[#FF6B00]/50" data-id="element-276">
                sin medidas claras.
              </span>
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-277">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-278" />
            <span className="text-gray-300 text-[15px]" data-id="element-279">
              No sabés{' '}
              <span className="font-bold text-white" data-id="element-280">
                qué proyectos de herrería fabricar
              </span>{' '}
              que realmente{' '}
              <span className="font-bold text-[#FF6B00]" data-id="element-281">se vendan</span> y te
              generen{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-282">
                alta rentabilidad.
              </span>
            </span>
          </li>
        </ul>

        {/* Video moved BELOW bullet points */}
        <div className="w-full -mx-4 px-0 md:mx-0 md:px-0" style={{
        marginLeft: '-1rem',
        marginRight: '-1rem',
        width: 'calc(100% + 2rem)'
      }} data-id="element-283">
          <div className="video-container" style={{
          aspectRatio: '16 / 9'
        }} data-id="element-284">
            <video autoPlay muted loop playsInline preload="none" style={{
            width: '100%',
            height: '100%',
            borderRadius: '0px',
            boxShadow: '0 0 30px rgba(0,0,0,0.6)',
            display: 'block',
            overflow: 'hidden',
            objectFit: 'contain'
          }} data-id="element-285">
              <source src="https://cdn.shopify.com/videos/c/o/v/58cdb96a46734ee7b8eed1850976ceb4.mp4" type="video/mp4" data-id="element-286" />
            </video>
          </div>
        </div>

        {/* Transition */}
        <p className="text-lg" data-id="element-287">
          Si quieres crear los proyectos con los que siempre soñaste —{' '}
          <span className="font-bold text-white" data-id="element-288">rápido y sin vueltas</span>...
          <br className="md:hidden" data-id="element-289" />
          en vez de pasar semanas adivinando medidas{' '}
          <br className="md:hidden" data-id="element-290" />o gastar una fortuna pagándole a otro...
        </p>
        <p className="text-lg" data-id="element-291">
          Y anhelas esa satisfacción de crear algo{' '}
          <span className="font-bold text-white" data-id="element-292">impresionante</span> con tus
          propias manos, <br className="md:hidden" data-id="element-293" />
          algo que la gente mire y diga{' '}
          <span className="italic text-white font-bold" data-id="element-294">
            "¿Tú hiciste eso?"
          </span>
          ...
        </p>

        {/* Image — planos demo */}
        <div className="my-4" data-id="element-295">
          <img src="https://cdn.magicpatterns.com/uploads/ipabubcqup3VguZeNaEoHE/ChatGPT_Image_20_ene_2026,_08_46_52_p.m._(1).png" alt="Proyectos de herrería industrial — Estanterías, escritorios, racks, armarios y más" className="w-full h-auto rounded-lg shadow-[0_0_30px_rgba(0,0,0,0.6)]" loading="lazy" decoding="async" width={800} height={500} data-id="element-296" />
        </div>

        {/* New video — above "más importante" callout */}
        <div style={{
        paddingLeft: '0px',
        paddingRight: '0px'
      }} data-id="element-297">
          <video autoPlay muted loop playsInline preload="none" style={{
          width: '100%',
          height: 'auto',
          borderRadius: '22px',
          boxShadow: '0 0 28px rgba(255,120,0,0.28)',
          display: 'block',
          overflow: 'hidden'
        }} data-id="element-298">
            <source src="https://cdn.shopify.com/videos/c/o/v/ead673babfa846e1a92fabb7cb5f0a39.mp4" type="video/mp4" data-id="element-299" />
          </video>
        </div>

        <p className="font-bold text-[#FF6B00] text-xl border-l-4 border-[#FF6B00] pl-4 py-2 bg-[#FF6B00]/5" data-id="element-300">
          Entonces esta puede ser la página <br className="md:hidden" data-id="element-301" />
          <span className="underline decoration-2" data-id="element-302">más importante</span> que
          lees en tu vida.
        </p>

        {/* ¿QUÉ VAS A LOGRAR? — Same visual style as "Este Sistema es para vos si..." */}
        <h2 className="text-2xl font-bold text-white mb-1" data-id="element-303">
          ¿Qué vas a{' '}
          <span className="text-[#FF6B00] underline decoration-[#FF6B00] decoration-2" data-id="element-304">
            lograr
          </span>
          ?
        </h2>

        <ul className="space-y-2" data-id="element-305">
          <li className="flex gap-3 items-start" data-id="element-306">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-307" />
            <span className="text-gray-300 text-[15px]" data-id="element-308">
              Vas a{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-309">
                dejar de improvisar
              </span>{' '}
              y empezar a trabajar con un{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-310">
                sistema claro
              </span>
              , incluso si hoy sentís que tu taller está desordenado o estancado
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-311">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-312" />
            <span className="text-gray-300 text-[15px]" data-id="element-313">
              Ahorrarás{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-314">
                tiempo, materiales y dinero
              </span>{' '}
              fabricando con{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-315">
                planos exactos
              </span>{' '}
              y procesos probados, sin ensayo y error
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-316">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-317" />
            <span className="text-gray-300 text-[15px]" data-id="element-318">
              Lograrás fabricar{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-319">
                proyectos de herrería modernos y rentables
              </span>
              , con terminaciones profesionales que te permitan{' '}
              <span className="font-bold text-white italic" data-id="element-320">cobrar mejor</span>
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-321">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-322" />
            <span className="text-gray-300 text-[15px]" data-id="element-323">
              Sabrás{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-324">
                qué proyectos fabricar
              </span>
              , cuáles se venden todo el año y cuáles te conviene evitar para no
              perder plata
            </span>
          </li>

          <li className="flex gap-3 items-start" data-id="element-325">
            <CircleCheck className="w-5 h-5 text-[#FF6B00] flex-shrink-0 mt-0.5" data-id="element-326" />
            <span className="text-gray-300 text-[15px]" data-id="element-327">
              Ganarás la{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-328">
                confianza
              </span>{' '}
              para aceptar trabajos más grandes y vas a saber{' '}
              <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-329">
                exactamente cuánto cobrar
              </span>{' '}
              en cada proyecto, sin dudar ni regalar tu trabajo
            </span>
          </li>
        </ul>

        {/* Product Intro */}
        <div className="text-center py-10" style={{
        paddingTop: '0px',
        paddingBottom: '0px'
      }} data-id="element-330">
          <p className="text-sm uppercase tracking-[0.2em] text-gray-500 mb-2 font-bold" data-id="element-331">
            PRESENTAMOS...
          </p>
          <img src="https://cdn.magicpatterns.com/uploads/ijfnPMf2L9ZoDp86PhZZ8a/ChatGPT_Image_20_ene_2026,_06_40_17_p.m._(1).png" alt="Sistema Maestro de Herrería — Sistema Listo Para Fabricar, Mapa Maestro del Taller, Motor de Presupuestos Profesionales" className="w-full max-w-2xl mx-auto h-auto mb-4" loading="lazy" decoding="async" width={800} height={500} data-id="element-332" />
          <h2 className="text-5xl md:text-6xl font-oswald text-white mb-3 tracking-tight" style={{
          fontSize: '28px'
        }} data-id="element-333">
            SISTEMA MAESTRO DE HERRERÍA
          </h2>
          <p className="text-xl md:text-2xl text-white font-medium mb-4 bg-[#1a1a1a] inline-block px-4 py-2 rounded border border-[#333]" data-id="element-334">
            "La Base de Datos Más Completa de Planos Metálicos Industriales"
          </p>
          <p className="text-gray-300 max-w-xl mx-auto mb-2 text-lg" data-id="element-335">
            Fabricá <span className="font-bold text-white" data-id="element-336">+600 proyectos</span>{' '}
            con planos paso a paso y{' '}
            <span className="font-bold text-white underline decoration-[#FF6B00]" data-id="element-337">
              medidas exactas
            </span>
            ... <br data-id="element-338" />
            <br data-id="element-339" />
            incluso si no tenés un taller enorme <br className="md:hidden" data-id="element-340" />
            ni herramientas costosas.
          </p>
          <p className="text-white font-bold max-w-xl mx-auto mb-3 text-lg" data-id="element-341">
            Mirá por dentro lo que vas a recibir hoy:
          </p>
        </div>
      </div>
    </section>;
}